import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import scrollToTop from '../../services/scrollToTop';

function ScrollToTop() {
    const { pathname } = useLocation();
    const previousPathnameRef = useRef(pathname);

    useEffect(() => {
        if (previousPathnameRef.current === pathname) {
            return;
        }
        previousPathnameRef.current = pathname;
        scrollToTop();
    }, [pathname]);

    return null;
}

export default ScrollToTop;
